import axios from 'services/axios'

export const logoutRequest = () => axios.get('auth/logout')
